module.exports = __webpack_public_path__ + "static/media/CB.4460b272.webp";